<template>
  <div>
    <!--#region -- Header ---->

    <div>
      <div class="caption-label"><span class="mr-2">{{ function_name }} </span></div>
      <div class="row">
        <div class="col">
          <div class="row">
            <div class="col">
              <div class="label mt-2">Search</div>
              <div class="row">

                <div class="col-1">
                  <div class="sub-label">FTIE:</div>
                  <b-form-input v-model="ftieId"
                                placeholder=""
                                label="FTIE:"
                                trim>
                  </b-form-input>

                </div>

                <div class="col-2">
                  <div class="sub-label">GRO Site:</div>
                  <b-form-select v-model="GRO" :options="GRO_options" label="GRO Site:" @change="onChangeRsmDirector(GRO)"></b-form-select>
                </div>

                <div class="col-2">
                  <div class="sub-label">Sales Director:</div>
                  <div v-if="directorOptionList.length == 0">
                    <b-form-input v-model="sales_director" placeholder="" label="Sales Director:" trim></b-form-input>
                  </div>

                  <div v-else>
                    <gtc-multi-select v-model="sales_director" key-field="value" text-field="text"
                                      :options="directorOptionList" select-class="w-100" class="w-100"></gtc-multi-select>
                  </div>

                </div>

                <div class="col-2">
                  <div class="sub-label">GRO RSM:
                  <button class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info" style="margin-top: -4px;"
                          v-b-tooltip.hover.topright title="Sales Who Create ES Request in SFDC"></button>
                  </div>
                  <div v-if="rsmOptionList.length == 0">
                    <b-form-input v-model="region_sales_manager" placeholder="" label="GRO RSM:" trim></b-form-input>
                  </div>

                  <div v-else>
                    <gtc-multi-select v-model="region_sales_manager"
                                      :options="rsmOptionList" select-class="w-100" class="w-100"></gtc-multi-select>
                  </div>
                </div>


                <div class="col-3">
                  <div class="sub-label">Customer:</div>
                  <b-form-input v-model="customerName"
                                placeholder=""
                                label="Customer:"
                                trim>
                  </b-form-input>
                </div>
              </div>

              <div class="label mt-2">Date Range</div>
              <div class="row">
                <div class="col-6">
                  <div class="sub-label">NRE Confirm Date:</div>

                  <div class="d-flex">
                    <input type="text" class="form-control" v-model="date_from" v-datepicker:to="date_to" />
                    <span class="font-weight-bold align-self-center">～</span>
                    <input type="text" class="form-control" v-model="date_to" v-datepicker:from="date_from" />
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
        <div class="col-auto align-self-end" style="width: 11.5rem">
          <b-button @click="searchInventory()" variant="primary">Search</b-button>
        </div>
      </div>
    </div>

    <!--#endregion -- Header ---->
    <!--#region -- Body ---->

    <div class="mt-3" v-if="already_first_search_flag==true">

      <!--#region -- Result Count ---->

      <div class="d-flex">
        <div v-if="rows && rows!==0 && nreFulfillmentData && nreFulfillmentData.length && searching === false" class="h5 font-weight-bold">
          {{ rows }} Results
          <button class="btn btn-sm btn-link p-0 btn-svg gtc-icon-download"
                  v-b-tooltip.hover title="Download Fulfillment Report"
                  @click="reportDownload()"></button>
        </div>
        <div v-else class="h5 font-weight-bold">
          {{ rows }} Results
        </div>
      </div>

      <!--#endregion -- Result Count ---->
      <!-- fix IE Browser min-height: 2.5rem -->
      <!-- NEW: NRE LEVEL IN MASTER TABLE -->
      <div class="table-responsive" style="min-height: 2.5rem">
        <b-table :fields="fieldsNRELevel" :items="nreFulfillmentData"
                 small
                 thead-class="thead-light text-dark"
                 :busy="searching"
                 style="width: calc(100% - 10px)">

          <template #table-busy>
            <div class="text-center text-danger my-2" rowspan="3">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>

          <template #cell(ftie_id)="data">
            <gtc-ftie :ftieId="data.item.ftie_id" />
          </template>


          <template #cell(nre_mp_total)="data">
            <div v-if="data.item.nre_mp_total">
              <span>{{ currencySign(data.item.currency) }} {{ data.item.nre_mp_total | comma }}</span>
            </div>
            <div v-else>
              <span>{{ currencySign(data.item.currency) }} {{ data.item.nre_mp_total }}</span>
            </div>
          </template>

          <template #cell(amortize_qty)="data">
            <div v-if="data.item.amortize_qty">


              <button v-b-modal.modal-1 class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info"
                      @click="showDetailData(data.item, data.item.ftie_id, 'nre')" v-b-tooltip.hover.left title="NRE Detail"></button>


              <span class="font-weight-bold">{{ data.item.amortize_qty | commaInt }}</span>
            </div>
            <div v-else>
              <span class="font-weight-bold">No Data</span>
            </div>
          </template>

          <template #cell(shipped_qty)="data">
            <div v-if="data.item.shipped_qty">
              <span>{{ data.item.shipped_qty | commaInt }}</span>
            </div>
            <div v-else>
              <span>{{ data.item.shipped_qty }}</span>
            </div>
          </template>

          <template #head(nre_fulfillment_rate)="data">
            <span class="font-weight-bold" v-b-tooltip.hover.righttop title="(Shipped/Amortize) * 100">{{ data.label }}</span>
          </template>

          <template #cell(nre_fulfillment_rate)="data">
            <span class="font-weight-bold">{{ data.item.nre_fulfillment_rate }}</span>
          </template>

          <template #head(nre_outstanding_payment)="data">
            <span class="font-weight-bold" v-b-tooltip.hover.righttop title="(Amortize QTY - Ship QTY) * Cost/Unit">{{ data.label }}</span>
          </template>

          <template #cell(nre_outstanding_payment)="data">
            <div v-if="data.item.nre_outstanding_payment">
              <span class="font-weight-bold">{{ currencySign(data.item.currency) }} {{ data.item.nre_outstanding_payment | comma }}</span>
            </div>
            <div v-else>
              <span class="font-weight-bold">{{ currencySign(data.item.currency) }} {{ data.item.nre_outstanding_payment }}</span>
            </div>
          </template>
        </b-table>
        <!-- REGION FOR POP-UP MODAL -->
        <b-modal centered size="lg"
                 id="modal-1"
                 :title=" `FTIE Ticket ${detailObjToShow.ftie_id} - NRE #${detailObjToShow.nre_id}`"
                 ok-only>
          <div class="header-col">
            <div>Currency</div>
            <div>{{ _.get(detailObjToShow, 'currency', '') }}</div>
          </div>
          <div class="header-col">
            <div>Salesforce Opportunity</div>
            <div>{{ _.get(detailObjToShow, 'opty_name', '') }}</div>
          </div>
          <div class="header-col">
            <div>ES Solution</div>
            <div>{{ _.get(detailObjToShow, 'es_solution', '') }}</div>
          </div>
          <div class="border-bottom"><br /></div>


          <!-- ADD V-IF : HQ Sales-->
          <b-table v-if="hqCostVisible === true && groCostVisible === true"
                   :fields="nreInfoFieldsHQSales"
                   :items="detailObjToShow.detailItems"
                   small
                   thead-class="thead-light text-dark"
                   :busy="searching"
                   ref="DetailModal"
                   style="width: calc(100% - 10px)">

            <template #cell(nre_id)="data">
              <span v-b-tooltip.hover.rightbottom
                    :title=" `SKU: ${data.item.sku_id_to_quote}`">{{ data.item.nre_id }}</span>
            </template>

            <template #cell(kickoff_date)="data">
              <span>{{ _.get(data.item, 'kickoff_date', '') | dateFormat }}</span>
            </template>

            <template #cell(nre_mp_total_hq_cost)="data">
              <span>{{ currencySign(detailObjToShow.currency) }} {{ data.item.nre_mp_total_hq_cost | comma }}</span>
            </template>
            <template #cell(nre_mp_total_gro_cost)="data">
              <span>{{ currencySign(detailObjToShow.currency) }} {{ data.item.nre_mp_total_gro_cost | comma }}</span>
            </template>
            <template #cell(nre_mp_total)="data">
              <span>{{ currencySign(detailObjToShow.currency) }} {{ data.item.nre_mp_total | comma }}</span>
            </template>

            <template #cell(amortize_qty)="data">
              <span>{{ data.item.amortize_qty | commaInt }}</span>
            </template>

            <template #cell(shipped_qty)="data">

              <button v-if="data.item.shipped_qty !== '0' && data.item.shipped_qty !== '' && data.item.shipped_qty !== 0"
                      class="btn btn-sm btn-link p-0 btn-svg fontawesome-chevron-down" type="button"
                      style="width: calc(1.3em + 0.3rem - 2.5px);height: calc(1.3em + 0.3rem + 0px);margin-bottom: 2px;"
                      data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample"
                      v-b-tooltip.hover.rightbottom title="Collapse for shipping PN"></button>
              <!--
                                  <button class="btn btn-sm btn-link p-0 btn-svg fontawesome-chevron-down" type="button"
                            style="width: calc(1.3em + 0.3rem + 0px);height: calc(1.3em + 0.3rem + 0px);margin-bottom: 2px;"
                            data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample"></button>

      -->
              <span>{{ data.item.shipped_qty | commaInt }}</span>
              <div v-if="data.item.shipped_qty !== '0' && data.item.shipped_qty !== '' && data.item.shipped_qty !== 0" class="collapse" id="collapseExample">
                <div class="card card-body" style="padding: 0.35px;">
                  <span>P/N {{data.item.customization_shipping_pn}}</span>
                  <ul id="example-1" style="padding-left: 20px;">
                    <li v-for="item in data.item.shipped_detail" :key="item">
                      {{ item }}
                    </li>
                  </ul>

                </div>
              </div>
            </template>

            <template #head(nre_outstanding_payment)="data">
              <span class="font-weight-bold" v-b-tooltip.hover.righttop title="(Amortize QTY - Ship QTY) * Cost/Unit">{{ data.label }}</span>
            </template>

            <template #cell(nre_outstanding_payment)="data">
              <div v-if="data.item.nre_outstanding_payment">
                <span class="font-weight-bold">{{ currencySign(detailObjToShow.currency) }} {{ data.item.nre_outstanding_payment | comma }}</span>
              </div>
              <div v-else>
                <span class="font-weight-bold">{{ currencySign(detailObjToShow.currency) }} 0.00</span>
              </div>

            </template>

          </b-table>

          <b-table v-if="hqCostVisible === true && groCostVisible === false"
                   :fields="nreInfoFieldsESPM"
                   :items="detailObjToShow.detailItems"
                   small
                   thead-class="thead-light text-dark"
                   :busy="searching"
                   ref="DetailModal"
                   style="width: calc(100% - 10px)">

            <template #cell(nre_id)="data">
              <span v-b-tooltip.hover.rightbottom
                    :title=" `SKU: ${data.item.sku_id_to_quote}`">{{ data.item.nre_id }}</span>
            </template>

            <template #cell(kickoff_date)="data">
              <span>{{ _.get(data.item, 'kickoff_date', '') | dateFormat }}</span>
            </template>

            <template #cell(nre_mp_total_hq_cost)="data">
              <span>{{ currencySign(detailObjToShow.currency) }} {{ data.item.nre_mp_total_hq_cost | comma }}</span>
            </template>

            <template #cell(amortize_qty)="data">
              <span>{{ data.item.amortize_qty | commaInt }}</span>
            </template>

            <template #cell(shipped_qty)="data">

              <button v-if="data.item.shipped_qty !== '0' && data.item.shipped_qty !== '' && data.item.shipped_qty !== 0"
                      class="btn btn-sm btn-link p-0 btn-svg fontawesome-chevron-down" type="button"
                      style="width: calc(1.3em + 0.3rem - 2.5px);height: calc(1.3em + 0.3rem + 0px);margin-bottom: 2px;"
                      data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample"
                      v-b-tooltip.hover.rightbottom title="Collapse for shipping PN"></button>
              <!--
                                  <button class="btn btn-sm btn-link p-0 btn-svg fontawesome-chevron-down" type="button"
                            style="width: calc(1.3em + 0.3rem + 0px);height: calc(1.3em + 0.3rem + 0px);margin-bottom: 2px;"
                            data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample"></button>

      -->
              <span>{{ data.item.shipped_qty | commaInt }}</span>
              <div v-if="data.item.shipped_qty !== '0' && data.item.shipped_qty !== '' && data.item.shipped_qty !== 0" class="collapse" id="collapseExample">
                <div class="card card-body" style="padding: 0.35px;">
                  <span>P/N {{data.item.customization_shipping_pn}}</span>
                  <ul id="example-1" style="padding-left: 20px;">
                    <li v-for="item in data.item.shipped_detail" :key="item">
                      {{ item }}
                    </li>
                  </ul>

                </div>
              </div>
            </template>

            <template #head(nre_outstanding_payment)="data">
              <span class="font-weight-bold" v-b-tooltip.hover.righttop title="(Amortize QTY - Ship QTY) * Cost/Unit">{{ data.label }}</span>
            </template>

            <template #cell(nre_outstanding_payment)="data">
              <div v-if="data.item.nre_outstanding_payment">
                <span class="font-weight-bold">{{ currencySign(detailObjToShow.currency) }} {{ data.item.nre_outstanding_payment | comma }}</span>
              </div>
              <div v-else>
                <span class="font-weight-bold">{{ currencySign(detailObjToShow.currency) }} 0.00</span>
              </div>

            </template>

          </b-table>

          <b-table v-if="hqCostVisible === false && groCostVisible === false"
                   :fields="nreInfoFields"
                   :items="detailObjToShow.detailItems"
                   small
                   thead-class="thead-light text-dark"
                   :busy="searching"
                   ref="DetailModal"
                   style="width: calc(100% - 10px)">

            <template #cell(nre_id)="data">
              <span v-b-tooltip.hover.rightbottom
                    :title=" `SKU: ${data.item.sku_id_to_quote}`">{{ data.item.nre_id }}</span>
            </template>

            <template #cell(kickoff_date)="data">
              <span>{{ _.get(data.item, 'kickoff_date', '') | dateFormat }}</span>
            </template>

            <template #cell(nre_mp_total)="data">
              <span>{{ currencySign(detailObjToShow.currency) }} {{ data.item.nre_mp_total | comma }}</span>
            </template>

            <template #cell(amortize_qty)="data">
              <span>{{ data.item.amortize_qty | commaInt }}</span>
            </template>

            <template #cell(shipped_qty)="data">

              <button v-if="data.item.shipped_qty !== '0' && data.item.shipped_qty !== '' && data.item.shipped_qty !== 0"
                      class="btn btn-sm btn-link p-0 btn-svg fontawesome-chevron-down" type="button"
                      style="width: calc(1.3em + 0.3rem - 2.5px);height: calc(1.3em + 0.3rem + 0px);margin-bottom: 2px;"
                      data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample"
                      v-b-tooltip.hover.rightbottom title="Collapse for shipping PN"></button>
              <!--
                                  <button class="btn btn-sm btn-link p-0 btn-svg fontawesome-chevron-down" type="button"
                            style="width: calc(1.3em + 0.3rem + 0px);height: calc(1.3em + 0.3rem + 0px);margin-bottom: 2px;"
                            data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample"></button>

      -->
              <span>{{ data.item.shipped_qty | commaInt }}</span>
              <div v-if="data.item.shipped_qty !== '0' && data.item.shipped_qty !== '' && data.item.shipped_qty !== 0" class="collapse" id="collapseExample">
                <div class="card card-body" style="padding: 0.35px;">
                  <span>P/N {{data.item.customization_shipping_pn}}</span>
                  <ul id="example-1" style="padding-left: 20px;">
                    <li v-for="item in data.item.shipped_detail" :key="item">
                      {{ item }}
                    </li>
                  </ul>

                </div>
              </div>
            </template>

            <template #head(nre_outstanding_payment)="data">
              <span class="font-weight-bold" v-b-tooltip.hover.righttop title="(Amortize QTY - Ship QTY) * Cost/Unit">{{ data.label }}</span>
            </template>

            <template #cell(nre_outstanding_payment)="data">
              <div v-if="data.item.nre_outstanding_payment">
                <span class="font-weight-bold">{{ currencySign(detailObjToShow.currency) }} {{ data.item.nre_outstanding_payment | comma }}</span>
              </div>
              <div v-else>
                <span class="font-weight-bold">{{ currencySign(detailObjToShow.currency) }} 0.00</span>
              </div>

            </template>

          </b-table>

        </b-modal>
        <!-- END REGION FOR MODAL -->

      </div>
      <!-- END OF NEW REGION -->
      <!-- !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! -->


      <div class="row mx-n1 align-items-center pr-3">
        <div class="px-1 col-auto ml-auto">
          Showing {{ 1 + (currentPage - 1) * perPage }} to {{ rows }} of {{rows}} rows
        </div>
       </div>
        <!--

     <div class="row mx-n1 align-items-center pr-3">
        <div class="px-1 col-auto ml-auto">
          Showing {{ 1 + (currentPage - 1) * perPage }} to {{ searchedData.length + (currentPage - 1) * perPage }} of {{rows}} rows
        </div>
        <div class="px-1 col-auto">
          <select class="form-control form-control-sm" v-model="perPage" v-on:change="perPageChange">
            <option>10</option>
            <option>20</option>
            <option>50</option>
            <option>100</option>
          </select>
        </div>
        <div class="px-1 col-auto">rows per page</div>
      </div>
    -->

      </div>

      <!--#endregion -- Body ---->

    </div>

</template>

<script>
  import * as moment from 'moment/moment';
  export default {
    name: 'dashboard',
    data() {
      return {
        function_name: 'NRE Fulfillment Analysis',
        currencySigns: {
          "USD": '$',
          "GBP": '£',
          "EUR": '€'
        },
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        keywords: '',
        authUrl: '',
        frontendUrl: '',
        thisPageLoadingCnt: 0,
        userInfo: '',
        userEmail: '',
        userFunctions: [],
        userRoles: [],
        userSites: [],
        date_from: '',
        date_to: '',
        customerName: '',
        fileName: '',
        downLoadSuccess: '',
        GRO: 'GUSA',
        GROText: '',
        GRO_options_default: '',
        GRO_options: [{ value: '', text: 'ALL' }],
        directorSelectionDic: '',
        rsmSelectionDic: '',
        directorOptionList: [],
        rsmOptionList: [],

        ftieId: '',
        region_sales_manager: '',
        sales_director: '',
        partNumber: '',
        optyName: '', //PM Stryker - TACOM - T800s Spiral 1 - 2020
        customizationPartNumber: '',
        customizationPartNumberSingle: '',
        shippingPnSelection: '',

        already_first_search_flag: false,
        fieldsNRELevel: [
          {
            key: 'ftie_id', label: 'FTIE ID', thClass: 'align-middle', sortable: true,
            tdStyle: { 'rowspan': "3" },
          },
          { key: 'nre_id', label: 'NRE ID', thClass: 'align-middle', sortable: true },
          { key: 'vertical', label: 'Vertical', thClass: 'align-middle', sortable: true },
          { key: 'sales_territory', label: 'Sub Vertical', thClass: 'align-middle', sortable: true },
          { key: 'account_name', label: 'Customer', thClass: 'align-middle', sortable: true },
          { key: 'gtc_owner', label: 'GTC Owner', thClass: 'align-middle', sortable: true },
          { key: 'hq_sales', label: 'GTC Sales', thClass: 'align-middle', sortable: true },

          { key: 'gro_owner', label: 'GRO Owner', thClass: 'align-middle', sortable: true },
          { key: 'gro_rsm', label: 'GRO RSM', thClass: 'align-middle', sortable: true },
          { key: 'gro_sales_director', label: 'GRO Sales Director', thClass: 'align-middle', sortable: true },
          { key: 'gro_sa_head', label: 'GRO SA Head', thClass: 'align-middle', sortable: true },
          { key: 'nre_mp_total', label: 'NRE MP (Sales Price)', thClass: 'align-middle', sortable: true },
          {
            key: 'amortize_qty', label: 'Amortize Qty', thClass: 'align-middle', tdClass: '',
            tdStyle: { 'min-width': '47rem', 'rowspan': "3" },
            sortable: true
          },
          { key: 'shipped_qty', label: 'Shipped QTY', thClass: 'align-middle', sortable: true },
          { key: 'nre_fulfillment_rate', label: 'Fulfillment Rate (%)', thClass: 'align-middle', sortable: true },
          { key: 'nre_outstanding_payment', label: 'Outstanding Payment', thClass: 'align-middle', sortable: true },
        ],

        nreInfoFields: [
          { key: 'nre_id', label: 'NRE', thClass: 'align-middle', sortable: true },
          { key: 'kickoff_date', label: 'Kick-off Date', thClass: 'align-middle', sortable: true },
          //{ key: 'real_sku_no', label: 'Real SKU NO', thClass: 'align-middle', sortable: true },
          //{ key: 'sfdc_opty_name', label: 'Opty Name', thClass: 'align-middle', sortable: true },
          //{ key: 'ref_sku', label: 'Ref SKU ID', thClass: 'align-middle', sortable: true },
          //{ key: 'sku_id_to_quote', label: 'SKU ID', thClass: 'align-middle', sortable: true },
          //{ key: 'nre_poc_total', label: 'NRE Total (PoC)', thClass: 'align-middle', sortable: true },
          { key: 'nre_mp_total', label: 'NRE Total (MP)', thClass: 'align-middle', sortable: true },
          //{ key: 'cost_per_unit_poc_total', label: 'Cost Per Unit Total (PoC)', thClass: 'align-middle', sortable: true },
          //{ key: 'cost_per_unit_mp_total', label: 'Cost Per Unit Total (MP)', thClass: 'align-middle', sortable: true },
          //{ key: 'demand_qty_poc', label: 'Demand Qty (PoC)', thClass: 'align-middle', sortable: true },
          //{ key: 'demand_qty_mp', label: 'Demand Qty (MP)', thClass: 'align-middle', sortable: true },
          { key: 'amortize_qty', label: 'Amortize Qty', thClass: 'align-middle', sortable: true },
          { key: 'shipped_qty', label: 'Shipped Qty', thClass: 'align-middle', sortable: true },
          { key: 'nre_fulfillment_rate', label: 'Fulfillment Rate(%)', thClass: 'align-middle', sortable: true },
          { key: 'nre_outstanding_payment', label: 'Outstanding Payment', thClass: 'align-middle', sortable: true },

        ],

        nreInfoFieldsESPM: [
          { key: 'nre_id', label: 'NRE', thClass: 'align-middle', sortable: true },
          { key: 'kickoff_date', label: 'Kick-off Date', thClass: 'align-middle', sortable: true }, //
          //{ key: 'sku_id_to_quote', label: 'SKU ID', thClass: 'align-middle', sortable: true },
          { key: 'nre_mp_total_hq_cost', label: 'NRE (HQ Cost)', thClass: 'align-middle', sortable: true },
          // key: 'nre_mp_total', label: 'NRE (Sales Price)', thClass: 'align-middle', sortable: true },
          { key: 'amortize_qty', label: 'Amortize Qty', thClass: 'align-middle', sortable: true },
          { key: 'shipped_qty', label: 'Shipped Qty', thClass: 'align-middle', sortable: true },
          { key: 'nre_fulfillment_rate', label: 'Fulfillment Rate(%)', thClass: 'align-middle', sortable: true },
          { key: 'nre_outstanding_payment', label: 'Outstanding Payment', thClass: 'align-middle', sortable: true },
        ],

        nreInfoFieldsHQSales: [
          { key: 'nre_id', label: 'NRE', thClass: 'align-middle', sortable: true },
          { key: 'kickoff_date', label: 'Kick-off Date', thClass: 'align-middle', sortable: true }, //
          //{ key: 'sku_id_to_quote', label: 'SKU ID', thClass: 'align-middle', sortable: true },
          { key: 'nre_mp_total_hq_cost', label: 'NRE (HQ Cost)', thClass: 'align-middle', sortable: true },
          { key: 'nre_mp_total_gro_cost', label: 'NRE (GRO Cost)', thClass: 'align-middle', sortable: true },
          { key: 'nre_mp_total', label: 'NRE (Sales Price)', thClass: 'align-middle', sortable: true },
          { key: 'amortize_qty', label: 'Amortize Qty', thClass: 'align-middle', sortable: true },
          { key: 'shipped_qty', label: 'Shipped Qty', thClass: 'align-middle', sortable: true },
          { key: 'nre_fulfillment_rate', label: 'Fulfillment Rate(%)', thClass: 'align-middle', sortable: true },
          { key: 'nre_outstanding_payment', label: 'Outstanding Payment', thClass: 'align-middle', sortable: true },
        ],

        /*
        self.nre_id = nre_id
        self.customization_shipping_pn = customization_shipping_pn
        self.sfdc_opty_name = sfdc_opty_name
        self.sfdc_opty_id = sfdc_opty_id
        self.account_name = account_name
        self.ref_sku = ref_sku
        self.nre_poc_total = None
        self.nre_mp_total = None
        self.amortize_qty = None # in NRE section
        self.quotations = quotations  # list of NreQuotation() object
        self.site = site
        self.gro_rsm = gro_rsm
        self.gro_sales_director = gro_sales_director
        self.gro_sa_head = gro_sa_head
        self.gtc_owner = gtc_owner
        self.gro_owner = gro_owner
        self.hq_sales = hq_sales
        self.demand_qty_mp = None
        self.demand_qty_poc = None
*/
        quotationFields: [
          { key: 'quote_type', label: 'Quote Type', thClass: 'align-middle', sortable: true },
          { key: 'quote_qty', label: 'Quote Qty', thClass: 'align-middle', sortable: true },
          { key: 'amortize_qty', label: 'Amortize Qty', thClass: 'align-middle', sortable: true },
          { key: 'currency', label: 'Currency', thClass: 'align-middle', sortable: true },
          { key: 'hq_cost', label: 'HQ Cost', thClass: 'align-middle', sortable: true },
          { key: 'tp', label: 'GRO Cost', thClass: 'align-middle', sortable: true },
          { key: 'sales_price', label: 'Sales Price', thClass: 'align-middle', sortable: true },

        ],
        shippedInfoFiedls: [
          { key: 'customization_shipping_pn', label: 'Shipping P/N', thClass: 'align-middle', sortable: true },
          { key: 'ship_date', label: 'Shipped Date', thClass: 'align-middle', sortable: true },
        ], //using 15836 to test collaps ship P/N list
        detailObjToShow: {
          detailItems: [],
          ftie_id: '',
          itemCount: 0,
          currency: '',
          opty_name: '',
          es_solution: ''
        },

        searchedData: [],
        searchedDataAll: [],
        nreFulfillmentData: [],
        mergedDataframe: '',
        login_user_name: '',
        searching: false,
        pageDisabled: false,
        pageLimit: 10,
        perPage: 10,
        currentPage: 1,
        nreTotalCount: '',
      }
    },
    created() {
      let self = this;

    },
    computed: {
      rows() {
        return this.nreTotalCount
        //return this.searchedData.length
      },
      date_from_computed() {
        let str = moment(this.date_from, 'YYYY-MMM-DD').format('YYYY-MM-DD');
        if (str === 'Invalid date') return '';
        else return str;
      },
      date_to_computed() {
        let str = moment(this.date_to, 'YYYY-MMM-DD').format('YYYY-MM-DD');
        if (str === 'Invalid date') return '';
        else return str;
      },

      hqCostVisible() {
        let self = this;
        if ((_.indexOf(self.userRoles, 'HQ_Sales') > -1) || (_.indexOf(self.userRoles, 'ES_PM_Leader') > -1) || (_.indexOf(self.userRoles, 'Admin') > -1)) {
          return true;
        }
        else {
          return false;
        }
      },

      groCostVisible() {
        let self = this;
        if ((_.indexOf(self.userRoles, 'HQ_Sales') > -1) || (_.indexOf(self.userRoles, 'Admin') > -1)) {
          return true;
        }
        else {
          return false;
        }
      },

      tableFields() {
        if (this.GRO === 'GUSA') {
          return [
            {
              key: 'ftie_id', label: 'FTIE ID', thClass: 'align-middle', sortable: true,
              tdStyle: { 'rowspan': "3" },
            },
            { key: 'vertical', label: 'Vertical', thClass: 'align-middle', sortable: true },
            { key: 'account_name', label: 'Customer', thClass: 'align-middle', sortable: true },
            { key: 'gtc_owner', label: 'GTC Owner', thClass: 'align-middle', sortable: true },
            { key: 'gro_owner', label: 'GRO Owner', thClass: 'align-middle', sortable: true },
            { key: 'hq_sales', label: 'GTC Sales', thClass: 'align-middle', sortable: true },
            { key: 'gro_rsm', label: 'GRO RSM', thClass: 'align-middle', sortable: true },
            { key: 'gro_sales_director', label: 'GRO Sales Director', thClass: 'align-middle', sortable: true },
            { key: 'gro_sa_head', label: 'GRO SA Head', thClass: 'align-middle', sortable: true },
            { key: 'total_nre_price_mp', label: 'NRE MP (Sales Price)', thClass: 'align-middle', sortable: true },
            //{ key: 'total_nre_price_poc', label: 'NRE PoC (Sales Price)', thClass: 'align-middle', sortable: true },
            {
              key: 'total_amortize_qty', label: 'Amortize Qty', thClass: 'align-middle', tdClass: '',
              tdStyle: { 'min-width': '47rem', 'rowspan': "3" },
              sortable: true
            },
            { key: 'total_shipped_qty', label: 'Shipped QTY', thClass: 'align-middle', sortable: true },
            { key: 'fulfillment_rate', label: 'Fulfillment Rate (%)', thClass: 'align-middle', sortable: true },
          ]
        } else {
          return [
            {
              key: 'ftie_id', label: 'FTIE ID', thClass: 'align-middle', sortable: true,
              tdStyle: { 'rowspan': "3" },
            },
            { key: 'account_name', label: 'Customer', thClass: 'align-middle', sortable: true },
            { key: 'gtc_owner', label: 'GTC Owner', thClass: 'align-middle', sortable: true },
            { key: 'gro_owner', label: 'GRO Owner', thClass: 'align-middle', sortable: true },
            { key: 'hq_sales', label: 'GTC Sales', thClass: 'align-middle', sortable: true },
            { key: 'gro_rsm', label: 'GRO RSM', thClass: 'align-middle', sortable: true },
            { key: 'gro_sales_director', label: 'GRO Sales Director', thClass: 'align-middle', sortable: true },
            { key: 'gro_sa_head', label: 'GRO SA Head', thClass: 'align-middle', sortable: true },
            { key: 'total_nre_price_mp', label: 'NRE MP (Sales Price)', thClass: 'align-middle', sortable: true },
            //{ key: 'total_nre_price_poc', label: 'NRE PoC (Sales Price)', thClass: 'align-middle', sortable: true },
            {
              key: 'total_amortize_qty', label: 'Amortize Qty', thClass: 'align-middle', tdClass: '',
              tdStyle: { 'min-width': '47rem', 'rowspan': "3" },
              sortable: true
            },
            { key: 'total_shipped_qty', label: 'Shipped QTY', thClass: 'align-middle', sortable: true },
            { key: 'fulfillment_rate', label: 'Fulfillment Rate (%)', thClass: 'align-middle', sortable: true },
          ]
        }
      }
    },
    mounted: function () {
      this.checkLoggedIn();
      this.authUrl = this.$options.filters['authUrl']();
      this.frontendUrl = this.$options.filters['frontendUrl']();
      if (this.$route.params.keywords) {
        this.keywords = this.$route.params.keywords;
        this.date_from = '';
        this.date_to = '';
        //this.searchInventory();
      }
      else {
        this.setDefaultDateForSearching();
      }
      this.thisPageLoadingCnt = 0;
    },
    methods: {

      setDefaultDateForSearching() {
        console.log("setDefaultDateForSearching");
        let self = this;
        //let today = moment();
        let defaultStartDate = moment().subtract(12, 'months');
        self.date_from = defaultStartDate.format('YYYY-MMM-DD');
        self.date_to = moment().format('YYYY-MMM-DD');
      },

      currencySign(ticketCurrency) {
        return this.currencySigns[ticketCurrency];
      },

      showDetailData(inputInfo, ftie_id, detailPurpose) {
        //console.log("inputInfoList::");
        //console.log(inputInfoList);
        let self = this;
        let items = [];
        let itemCnt = 0
        /*
        if ('nre' === detailPurpose) {
          items = JSON.parse(JSON.stringify(inputInfoList));
        }

        if (inputInfoList !== null) {
          itemCnt = _.size(inputInfoList)
        }
        */

        self.detailObjToShow = {
          detailItems: [inputInfo],
          ftie_id: ftie_id,
          nre_id: inputInfo.nre_id,
          itemCount: 1,
          currency: inputInfo.currency,
          opty_name: inputInfo.sfdc_opty_name,
          es_solution: inputInfo.es_solution
        };

        //console.log("detailObjToShow::");
        //console.log(self.detailObjToShow);
        //self.$refs['DetailModal'].show();
      },

      tooltipTitle(data, stage_index) {
        let self = this;
        var signing_stage = data.item.signing_stages[stage_index];
        return _.trim(self.stageTip[stage_index] + ' ' + _.trim(_.get(signing_stage, 'status_name', '')))
      },

      tooltipReason(data) {
        let self = this;
        return _.trim(_.get(data.item, 'reject_reason', ''))
      },

      logout() {
        this.$session.destroy();
        this.$store.commit('clearToken');
        var url = this.$root.baseUrl + '/auth/logout/'
        this.$axios.get(url)
          .then((res) => {
            console.log('logout');
            this.$router.push("/");
          })
        window.location = this.authUrl + 'Auth/SignOut' + '?redirect_uri=' + encodeURIComponent(this.frontendUrl + 'azure-login');
      },
      checkLoggedIn() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');

        /*
        console.log("this.$session.get('options')");
        console.log(options);
        console.log(options.model_list);
        console.log("login_user_name:");
        console.log(user_name);
        console.log("user_email:");
        console.log(user_email);
        console.log("user_functions:");
        console.log(user_functions);
        console.log("user_roles:");
        console.log(user_roles);
        console.log("user_site:");
        console.log(user_site);
        */


        this.login_user_name = user_name;

        //this.ownerSelectionDic = options.owner_dic_with_region_key;

        this.userEmail = user_email;
        this.userFunctions = user_functions;
        this.userRoles = user_roles;
        this.userSites = user_site;
        this.rsmSelectionDic = options.rsm_dic_with_region_key;
        this.directorSelectionDic = options.director_dic_with_region_key;
        /*
        var i;
        var model_option_new = new Array();
        for (i = 0; i < options.model_list.length; i++) {
          model_option_new.push({ value: options.model_list[i], text: options.model_list[i] })
        }
        this.model_options = this.model_options.concat(model_option_new);
        */
        var gro_option_new = new Array();
        for (var i = 0; i < options.gro_opt_val_list.length; i++) {
          gro_option_new.push({ value: options.gro_opt_val_list[i], text: options.gro_opt_text_list[i] })
        }
        this.GRO_options = gro_option_new;

        /*  Region: BUILD Default value for GRO */
        if (_.indexOf(options.gro_opt_val_list, 'GUSA') > -1) {
          this.GRO_options_default = 'GUSA';
          this.GRO = 'GUSA';
          this.GROText = 'GUSA';
        }
        else {
          if (gro_option_new > 1) {
            this.GRO_options_default = gro_option_new[1].value;
            this.GRO = gro_option_new[1].value;
            this.GROText = gro_option_new[1].text;
          }
          else {
            if (gro_option_new.length == 1) {
              this.GRO_options_default = gro_option_new[0].value;
              this.GRO = gro_option_new[0].value;
              this.GROText = gro_option_new[0].text;
            }
          }
        }
        /*  END Region: BUILD Default value for GRO */

        let rsmOptions = _.get(this.rsmSelectionDic, this.GROText, ['']);
        let directorOptions = _.get(this.directorSelectionDic, this.GROText, ['']);

        /* Region: build multi options for RSM, Directors */
        var directorMultiOptionList = new Array();
        //directorMultiOptionList.push({ value: '', text: '' });
        for (var i = 0; i < directorOptions.length; i++) {
          directorMultiOptionList.push({ value: directorOptions[i], text: directorOptions[i] })
        }
        this.directorOptionList = this.directorOptionList.concat(directorMultiOptionList);
        /* Set Default Value for sales_director */
        if (directorOptions.length > 0) {
          this.sales_director = new Array();
          this.sales_director.push({ value: directorOptions[0], text: directorOptions[0] });
          //this.sales_director = [{ value: 'dante.conrad', text: 'dante.conrad' }];
        }
        else {
          this.sales_director = '';
        }

        var rsmMultiOptionList = new Array();
        //directorMultiOptionList.push({ value: '', text: '' });
        for (var i = 0; i < rsmOptions.length; i++) {
          rsmMultiOptionList.push({ value: rsmOptions[i], text: rsmOptions[i] })
        }
        this.rsmOptionList = this.rsmOptionList.concat(rsmMultiOptionList);

        /* Set Default Value for region_sales_manager */
        if (rsmOptions.length === 0) {
          this.region_sales_manager = '';
        }


        console.log("[Default-Multi]directorOptionList:");
        console.log(this.directorOptionList);
        console.log("sales_director(defualt):");
        console.log(this.sales_director);

        console.log("[Default-Multi]rsmOptionList:");
        console.log(this.rsmOptionList);
        console.log("region_sales_manager(defualt):");
        console.log(this.region_sales_manager);
        /* End Region */
      },

      onChangeRsmDirector(GRO) {
        //console.log("onChangeRsmDirector select GRO = ");
        //console.log(GRO);
        let groText = GRO;
        if ('' === GRO) {
          groText = 'ALL';
        }
        var options = this.$session.get('options');
        let indexStr = GRO;
        let rsmOptions = _.get(this.rsmSelectionDic, indexStr, ['']);
        let directorOptions = _.get(this.directorSelectionDic, indexStr, ['']);

        /* Region: build multi options for RSM, Directors */
        var directorMultiOptionList = new Array();
        //directorMultiOptionList.push({ value: '', text: '' });
        for (var i = 0; i < directorOptions.length; i++) {
          directorMultiOptionList.push({ value: directorOptions[i], text: directorOptions[i] })
        }
        this.directorOptionList = directorMultiOptionList;

        /* Set Default Value for sales_director */
        if (directorOptions.length > 0) {
          //this.sales_director = [{ value: 'dante.conrad', text: 'dante.conrad' }];
          this.sales_director = new Array();
          this.sales_director.push({ value: directorOptions[0], text: directorOptions[0] });
        }
        else {
          this.sales_director = '';
        }
        var rsmMultiOptionList = new Array();
        //directorMultiOptionList.push({ value: '', text: '' });
        for (var i = 0; i < rsmOptions.length; i++) {
          rsmMultiOptionList.push({ value: rsmOptions[i], text: rsmOptions[i] })
        }
        this.rsmOptionList = rsmMultiOptionList;
        /* Set Default Value for region_sales_manager */
        if (rsmOptions.length === 0) {
          this.region_sales_manager = '';
        }

        /*
        console.log("directorOptionList:");
        console.log(this.directorOptionList);
        console.log("sales_director(defualt):");
        console.log(this.sales_director);

        console.log("rsmOptionList:");
        console.log(this.rsmOptionList);
        console.log("region_sales_manager(defualt):");
        console.log(this.region_sales_manager);
        */

        //this.GROOwnerList = this.ownerSelectionDic[GRO]['GRO_owners'];
      },

      // TODO: NEW- DOWNLOAD
      reportDownload() {
        let self = this;
        let url = self.$root.baseUrl + '/nre-fulfillment/report/download/';
        console.log('####nre-fulfillment - download######');

        //////
        let ftieList = [];
        if (self.ftieId !== '') {
          ftieList.push(self.ftieId);
        }

        let partNumberList = [];
        if (self.partNumber !== '') {
          partNumberList.push(self.partNumber);
        }

        let customizationShippingPnSelected = [];
        if (self.customizationPartNumber.length == 0) {
          customizationShippingPnSelected = '';
        } else {
          for (var i = 0; i < self.customizationPartNumber.length; i++) {
            customizationShippingPnSelected.push(self.customizationPartNumber[i]['value'])
          }
        }

        // REGION: build site for searching
        let siteList = [];
        if (typeof self.GRO === 'string') {
          if (self.GRO !== '') {
            siteList.push(self.GRO);
          }
        }
        else {
          if (self.GRO.length == 0) {
            siteList.push("");
          } else {
            for (var i = 0; i < self.GRO.length; i++) {
              siteList.push(self.GRO[i]);
            }
          }
        }


        // REGION: build rsmList for searching
        let rsmList = [];
        if (typeof self.region_sales_manager === 'string') {
          if (self.region_sales_manager !== '') {
            rsmList.push(self.region_sales_manager);
          }
        }
        else {
          if (self.region_sales_manager.length == 0) {
            rsmList.push("");
          } else {
            for (var i = 0; i < self.region_sales_manager.length; i++) {
              rsmList.push(self.region_sales_manager[i]['value']);
            }
          }
        }
        console.log("RSM for searching::");
        console.log(rsmList);

        // REGION: build salesDirectorList for searching
        let salesDirectorList = [];

        if (typeof self.sales_director === 'string') {
          if (self.sales_director !== '') {
            salesDirectorList.push(self.sales_director); //dante.conrad
          }
        }
        else {
          if (self.sales_director.length == 0) {
            salesDirectorList.push("");
          } else {
            for (var i = 0; i < self.sales_director.length; i++) {
              salesDirectorList.push(self.sales_director[i]['value']);
            }
          }
        }
        console.log("sales director for searching::");
        console.log(self.sales_director);

        let downloadTime = new Date();
        downloadTime = downloadTime.toISOString();

        let request_data = {
          part_number: partNumberList,
          ftie_id: ftieList,//['15920', '15974'],//ftieList,//['15301', '15974', '14662'],
          opty_name: [], //optyList TO REMOVE
          account_name: self.customerName,
          sales_director: salesDirectorList, //['dante.conrad'],
          region_sales_manager: rsmList,
          site: siteList, //['GUSA'],
          user_functions: self.userFunctions,
          user_roles: self.userRoles,
          record_per_page: self.perPage,
          page_index: self.currentPage,
          keywords: self.keywords,
          customization_shipping_pn: customizationShippingPnSelected,
          date_from: self.date_from_computed,
          date_to: self.date_to_computed,
          downloadTime: downloadTime,
          mergedDataframe: self.mergedDataframe
        };
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };

        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params, responseType: 'arraybuffer' })
          .then((res) => {
            if (res.status === 200) {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement('a');
              link.href = url;
              let dateTimeStr = _.replace(downloadTime, '.', '');
              dateTimeStr = _.replace(dateTimeStr, ':', '');
              dateTimeStr = _.replace(dateTimeStr, '-', '');
              let file_name = 'fulfillment_report_' + dateTimeStr + '.xlsx';
              console.log("file_name =" + file_name);
              link.setAttribute('download', file_name);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.authUrl + 'Auth/SignOut?redirect_uri=' + encodeURIComponent(self.frontendUrl + 'azure-login');
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });

      },


      // TODO: NEW
      searchInventory() {
        if (this.thisPageLoadingCnt == 0) {
          this.already_first_search_flag = false;
          this.thisPageLoadingCnt = this.thisPageLoadingCnt + 1;
        }
        this.currentPage = 1;
        this.getFulfillmentData();
      },
      pageChange(page) {
        this.currentPage = page;
        his.getFulfillmentData();
        /*
        if (this.searchedDataAll && this.searchedDataAll.length > 0 && this.searchedDataAll !== '' && this.nreTotalCount !== null && this.nreTotalCount > 0) {
          this.buildDataIndexbyPage();
        }
        else {
          this.getFulfillmentData(); // api call
        }
*/

      },
      perPageChange() {
        this.currentPage = 1;
        this.getFulfillmentData(); // api call
      },


      // TODO: Get Fulfillment Data
      getFulfillmentData() {
        let self = this;
        if (self.thisPageLoadingCnt == 0) {
          self.already_first_search_flag = false;
          self.thisPageLoadingCnt = self.thisPageLoadingCnt + 1;
        }
        let url = self.$root.baseUrl + '/nre-fulfillment/report/';
        console.log('####nre fulfillment######');
        let ftieList = [];
        if (self.ftieId !== '') {
          ftieList.push(self.ftieId);
        }

        let partNumberList = [];
        if (self.partNumber !== '') {
          partNumberList.push(self.partNumber);
        }

        let customizationShippingPnSelected = [];
        if (self.customizationPartNumber.length == 0) {
          customizationShippingPnSelected = '';
        } else {
          for (var i = 0; i < self.customizationPartNumber.length; i++) {
            customizationShippingPnSelected.push(self.customizationPartNumber[i]['value'])
          }
        }


        // REGION: build site for searching
        let siteList = [];
        if (typeof self.GRO === 'string') {
          if (self.GRO !== '') {
            siteList.push(self.GRO);
          }
        }
        else {
          if (self.GRO.length == 0) {
            siteList.push("");
          } else {
            for (var i = 0; i < self.GRO.length; i++) {
              siteList.push(self.GRO[i]);
            }
          }
        }

        // REGION: build rsmList for searching
        let rsmList = [];
        if (typeof self.region_sales_manager === 'string') {
          if (self.region_sales_manager !== '') {
            rsmList.push(self.region_sales_manager);
          }
        }
        else {
          if (self.region_sales_manager.length == 0) {
            rsmList.push("");
          } else {
            for (var i = 0; i < self.region_sales_manager.length; i++) {
              rsmList.push(self.region_sales_manager[i]['value']);
            }
          }
        }
        console.log("RSM for searching::");
        console.log(rsmList);

        // REGION: build salesDirectorList for searching
        let salesDirectorList = [];

        if (typeof self.sales_director === 'string') {
          if (self.sales_director !== '') {
            salesDirectorList.push(self.sales_director); //dante.conrad
          }
        }
        else {
          if (self.sales_director.length == 0) {
            salesDirectorList.push("");
          } else {
            for (var i = 0; i < self.sales_director.length; i++) {
              salesDirectorList.push(self.sales_director[i]['value']);
            }
          }
        }
        console.log("sales director for searching::");
        console.log(salesDirectorList);


        let request_data = {
          part_number: partNumberList,
          ftie_id: ftieList,//['15920', '15974'],//ftieList,//['15301', '15974', '14662'],
          opty_name: [], //optyList TO REMOVE
          account_name: self.customerName,
          sales_director: salesDirectorList, //['dante.conrad'],
          region_sales_manager: rsmList,
          site: siteList, //['GUSA'],
          user_functions: self.userFunctions,
          user_roles: self.userRoles,
          record_per_page: self.perPage,
          page_index: self.currentPage,
          keywords: self.keywords,
          customization_shipping_pn: customizationShippingPnSelected,
          date_from: self.date_from_computed,
          date_to: self.date_to_computed,
        };
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };

        self.searching = true;
        let searchedData = [];
        let searchedDataAll = [];
        let nreFulfillmentData = [];
        let nreTotalCount = 0;
        let mergedDfResult = '';
        if (self.already_first_search_flag == false) {
          eventHub.$emit('loading', true);
        }
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              //searchedData = JSON.parse(res['nre_data']);
              //searchedDataAll = JSON.parse(res['nre_data']);
              //searchedData = JSON.parse(res['nre_data']);//res['nre_data'];
              //if (res['nre_data'] == '[]') {
              //  searchedDataAll = [];
              //  nreFulfillmentData = [];
              //} else {
              //  searchedDataAll = JSON.parse(res['nre_data']);
              //  nreFulfillmentData = JSON.parse(res['nre_data']);
              //}
              searchedDataAll = JSON.parse(res['nre_data']);
              nreFulfillmentData = JSON.parse(res['nre_data']);
              mergedDfResult = res['merged_dataframe'];
              nreTotalCount = parseInt(res['data_count']);
              //nreTotalCount = parseInt(searchedData['nre_count']);

              //console.log(searchedData);

              self.shippingPnSelection = '';
              self.customizationPartNumber = '';

              // END REGION
            }

            else if (response.status === 204) {
              self.$message.warning('No data found! Please try other selection or click reset to search all.', self.function_name);
              console.log(res.description);
              self.shippingPnSelection = '';
              self.customizationPartNumber = '';
            }

            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.authUrl + 'Auth/SignOut?redirect_uri=' + encodeURIComponent(self.frontendUrl + 'azure-login');
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              self.shippingPnSelection = '';
              self.customizationPartNumber = '';
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
            self.shippingPnSelection = '';
            self.customizationPartNumber = '';
          })
          .finally(() => {
            self.searching = false;
            self.already_first_search_flag = true;
            if (self.already_first_search_flag == true) {
              eventHub.$emit('loading', false);
            }
            self.nreFulfillmentData = nreFulfillmentData;
            self.searchedData = searchedData;
            self.searchedDataAll = searchedDataAll;
            self.nreTotalCount = nreTotalCount;
            self.mergedDataframe = mergedDfResult;
            // REGION:: TODO: REBUILD LIST BY PAGE

            // END REGION:: TODO: REBUILD LIST BY PAGE
          })
      },

      resetFilterCondition() {
        let self = this;
        self.keywords = '';
        //self.my_status = [];
        //self.model = '';
        self.ftieId = '';
        self.optyName = '';
        self.partNumber = '';
        self.shippingPnSelection = '';
        self.customizationPartNumber = '';
        self.customizationPartNumberSingle = '';
        //self.GRO = '';
        self.date_from = '';
        self.date_to = '';
        //self.NRE_status = [{ value: 'Waiting', text: 'Ongoing' }, { value: 'W', text: 'Awaiting' }];//{Ongoing, Waiting}
        //self.NRE_status = [{ value: "Waiting", text: "Ongoing" }, { value: "W", text: "Awaiting" }, { value: "Completed", text: "Completed" }, { value: "Rejected", text: "Rejected" }, { value: "Deferred", text: "Deferred" }];
        //self.ticket_status = [{ value: 'Open', text: 'Open' }, { value: 'Solved', text: 'Solved' }, { value: 'Close', text: 'Closed' }, { value: 'Deferred', text: 'Deferred' }]; //{Open, Solved, Closed, Deferred}
      },
      buildDataIndexbyPage() {
        let self = this;
        //self.perPage
        //self.currentPage
        //self.
        if (self.searchedDataAll && self.searchedDataAll.length > 0 && self.nreTotalCount !== null && self.nreTotalCount > 0) {
          let startIndex = (self.currentPage - 1) * self.perPage;
          if (startIndex < self.nreTotalCount - 1) {
            let endIndex = (startIndex + self.perPage);
            if (endIndex > self.nreTotalCount) {
              endIndex = self.nreTotalCount;
            }
            self.searchedData = _.slice(self.searchedDataAll, startIndex, endIndex);
          }
        }
      }
    },
    filters: {

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/NreFulfillmentDashboard.vue